import { Link } from "react-router-dom";
import type { Game } from "@/types";
import { GameImage } from "./GameImage";
import { RatingBadge } from "@/components/ui/RatingBadge";

interface Props {
  games: Game[];
}

export function SimilarGamesStrip({ games }: Props) {
  if (!games || games.length === 0) return null;
  return (
    <section className="mt-12">
      <h2 className="mb-6 text-2xl font-bold text-gray-900">Panašūs žaidimai</h2>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {games.map((g) => {
          const img = g.imageUrl || g.thumbnailUrl;
          return (
            <Link
              key={g.id}
              to={`/games/${g.id}${g.slug ? `-${g.slug}` : ""}`}
              className="group overflow-hidden rounded-xl border border-gray-200 bg-white transition-shadow hover:shadow-md"
            >
              <div className="aspect-square bg-gray-100">
                <GameImage src={img} alt={g.title} className="h-full w-full object-cover transition-transform group-hover:scale-105" />
              </div>
              <div className="p-2">
                <p className="line-clamp-2 text-xs font-semibold text-gray-900 group-hover:text-primary-800">
                  {g.title}
                </p>
                <div className="mt-1 flex items-center justify-between">
                  {g.displayRating != null ? (
                    <RatingBadge rating={g.displayRating} source={g.ratingSource ?? null} />
                  ) : (
                    <span />
                  )}
                  {g.lowestPrice != null && (
                    <span className="text-xs font-bold text-primary-800">
                      nuo {g.lowestPrice.toFixed(0)}€
                    </span>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
